import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StatusHistoryResponse, StatusResponse } from '../domain/status.model';

@Injectable({ providedIn: 'root' })
export class StatusApiService {
  private readonly base = `${environment.publicApiUrl}/status`;

  constructor(private http: HttpClient) { }

  /**
   * `fresh` is for the page's refresh button. The API allows browsers to cache an answer for a minute, so
   * without a differing URL a click within that minute would replay the cached copy and look broken.
   */
  getStatus(fresh = false): Observable<StatusResponse> {
    return this.http.get<StatusResponse>(this.base, { params: this.cacheBuster(fresh) });
  }

  getHistory(days = 90, fresh = false): Observable<StatusHistoryResponse> {
    return this.http.get<StatusHistoryResponse>(`${this.base}/history`, {
      params: this.cacheBuster(fresh).set('days', days),
    });
  }

  private cacheBuster(fresh: boolean): HttpParams {
    return fresh ? new HttpParams().set('_', Date.now()) : new HttpParams();
  }
}
